import React from "react";
import { Link, useLocation } from "react-router-dom";
import { MyHomeIcon } from "../../Assets/svg/MyIcons";

const BREADCRUMB_LABELS = {
  "country-document": "KYC Country Document",
  "documentation-type": "KYC Country Document Type",
};

const BreadcrumbsComponent = () => {
  const location = useLocation();
  const pathnames = location.pathname.split("/").filter((x) => x);

  const formatBreadcrumb = (text) => {
    if (BREADCRUMB_LABELS[text]) return BREADCRUMB_LABELS[text];
    return text
      .split("-")
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
      .join(" ");
  };

  return (
    <div className="py-5 px-5 mb-4  mt-5">
      <nav aria-label="breadcrumb">
        <ol className="breadcrumb mb-0 p-0">
          <li className="breadcrumb-item">
            <Link to="/" className="text-decoration-none text-muted">
              <MyHomeIcon sx={{ fontSize: 20, verticalAlign: "middle" }} />
              Home
            </Link>
          </li>
          {pathnames.map((value, index) => {
            const to = `/${pathnames.slice(0, index + 1).join("/")}`;

            return index === pathnames.length - 1 ? (
              <li
                className="breadcrumb-item active text-primary"
                aria-current="page"
                key={to}
              >
                {formatBreadcrumb(value)}
              </li>
            ) : (
              <li className="breadcrumb-item" key={to}>
                <Link to={to} className="text-decoration-none text-dark">
                  {formatBreadcrumb(value)}
                </Link>
              </li>
            );
          })}
        </ol>
      </nav>
    </div>
  );
};

export default BreadcrumbsComponent;
